import {defineStore} from 'pinia'

export const useLanguageStore = defineStore({
    id: 'language',

    state: () => ({
        // default language
        currentAppLanguage: 'ca',
        appLanguages: [
            {
                code: 'ca',
                webcode: 'cat',
                name: 'Català'
            },
            {
                code: 'es',
                webcode: 'es',
                name: 'Español'
            },
            {
                code: 'en',
                webcode: 'en',
                name: 'English'
            },
            {
                code: 'fr',
                webcode: 'fr',
                name: 'Français'
            }
        ]
    }),

    actions: {

        fetchCurrentLanguage() {
            const localStorageLang = localStorage.getItem('currentAppLanguage')

            if(localStorageLang) {
                if(this.appLanguages.filter((el) => el.code === localStorageLang).length) {
                    this.selectCurrentAppLanguage(localStorageLang)
                }
            } else {
                const navigatorLang = navigator.language
                if(navigatorLang) {
                    const navigatorLangCode = navigatorLang.split('-')[0]
                    if(this.appLanguages.filter((el) => el.code === navigatorLangCode).length) {
                        this.selectCurrentAppLanguage(navigatorLangCode)
                    }
                }
            }
        },

        selectCurrentAppLanguage(code) {
            if(this.appLanguages.filter((el) => el.code === code).length) {
                this.currentAppLanguage = code
                localStorage.setItem('currentAppLanguage', code)
            }
        }
    }
})
